import { SET_CAMPAIGNS_DATA, SET_CAMPAIGNS_LOADER } from '../actions/action-types';
import { LOGOUT } from '../actions/action-types';

const initialState = {
  campaigns: [],
  loading: false,
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  totalRevenue: 0,
  totalQuantity: 0,
  totalRecordsInDB: 0,
};

const campaignsReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CAMPAIGNS_DATA:
      return {
        ...state,
        campaigns: payload.rows,
        rowsCount: payload.count,
        totalRecordsInDB: payload.totalRecordsInDB,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
        totalRevenue: payload.totalRevenue,
        totalQuantity: payload.totalQuantity,
      };
    case SET_CAMPAIGNS_LOADER:
      return { ...state, loading: payload };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { campaignsReducers };
